<script>
const debounce = require("lodash.debounce");

export default {
    data() {
        return {
            showInput: false,
            selectIndex: 0,
            loading: false,
            loaded: false,
            url: null
        };
    },
    methods: {
        closeSearch() {
            this.showInput = false;
            setTimeout(() => {
                this.$store.commit("toggleSearch", false);
                // this.$store.commit("searchTerm", "")
            }, 700);
        },
        adjustIndex(val) {
            if (val == -1 && this.selectIndex == 0) {
                return;
            }
            if (val == 1 && this.selectIndex == this.entries.length + 1) {
                return;
            }
            this.selectIndex += val;
        },
        selectResult() {
            if (this.selectIndex == 0) {
                this.url = `/search?s=all&q=${this.searchTerm}`;
            } else {
                let result = this.entries[this.selectIndex - 1];
                this.url = result.url;
            }
            this.closeSearch();
            window.location = this.url;
        },
        async getEntries() {
            await axios
                .get("/all-entries-meta.json")
                .then(response => {
                    this.loading = false;
                    this.loaded = true;
                    this.$store.commit("entries", response.data.data);
                })
                .catch(e => {
                    console.log(e.response);
                });
        },
        async getCategories() {
            await axios
                .get("/categories.json")
                .then(response => {
                    this.loading = false;
                    this.loaded = true;
                    this.$store.commit("categories", response.data.data);
                })
                .catch(e => {
                    console.log(e.response);
                });
        }
    },
    computed: {
        showSearch() {
            return this.$store.getters.showSearch;
        },
        searchTerm: {
            get() {
                return this.$store.getters.searchTerm;
            },
            set(val) {
                this.$store.commit("searchTerm", val);
            }
        },
        entries() {
            return this.$store.getters.entries;
        },
        showSearchResults() {
            return this.$store.getters.searchTerm.length > 1;
        }
    },
    watch: {
        showSearch(show) {
            setTimeout(() => {
                if (show) {
                    this.showInput = true;

                    if (this.entries < 1) {
                        this.loading = true;
                        this.getEntries();
                        this.getCategories();
                    }

                    setTimeout(() => {
                        document.getElementById("main-search").focus();
                    }, 200);
                }
            }, 200);
        },
        searchTerm: debounce(newVal => {
            console.log(newVal);
            window.ga("send", "pageview", `/search?q=${newVal}`);
        }, 1000)
    }
};
</script>

<template>
    <div
        class="fixed pin z-40 flex flex-col justify-start pt-12 items-center"
        v-if="showSearch"
        @keyup.esc="closeSearch"
        @keydown.down="adjustIndex(1)"
        @keydown.up="adjustIndex(-1)"
        @keyup.enter="selectResult"
    >
        <div class="absolute pin bg-black opacity-75"></div>

        <transition name="bounce-left">
            <div
                class="text-md md:text-xl relative z-50 bg-white shadow-lg rounded-lg w-4/5 md:w-3/4 max-w-md"
                v-if="showInput"
            >
                <div class="flex flex-row justify-between items-center search-wrapper">
                    <input
                        type="search"
                        v-model="searchTerm"
                        class="max-w-full w-full p-4 rounded-lg font-bold outline-none"
                        id="main-search"
                        @keyup.esc="closeSearch"
                        placeholder="What are you looking for?"
                    />
                    <div
                        v-if="loading && !loaded"
                        class="flex items-center justify-center mr-6 h-10 w-10 content"
                    >
                        <div class="is-loading dark-spinner large-spinner">
                            <span></span>
                        </div>
                    </div>
                    <div
                        v-if="searchTerm"
                        class="flex items-center justify-center mr-4 h-10 w-auto content text-grey text-sm font-bold text-right whitespace-no-wrap"
                    >{{ entries.length }} Results</div>
                </div>

                <button
                    @click="closeSearch"
                    class="bg-white hover:bg-purple hover:text-white absolute pin-r pin-t rounded-full p-1 w-8 h-8 -mt-4 -mr-4 text-purple flex justify-center items-center shadow-lg z-60 border-4 border-purple-light"
                    style="outline: none"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="block w-3 h-3 fill-current"
                    >
                        <path
                            d="M23.7 22.3L13.42 12l10.3-10.3A1 1 0 1 0 22.29.3L12 10.58 1.7.29A1 1 0 0 0 .3 1.71L10.58 12 .29 22.3a1 1 0 1 0 1.42 1.4L12 13.42l10.3 10.3a1 1 0 1 0 1.4-1.42z"
                        />
                        <g>
                            <path fill="none" d="M0 0h24v24H0z" />
                        </g>
                    </svg>
                </button>

                <div v-if="showSearchResults" class="max-h-80vh overflow-y-scroll">
                    <a
                        class="p-4 border-t no-underline cursor-pointer flex justify-between items-start text-base hover:bg-grey-lighter hover:text-black"
                        :class="selectIndex == 0 ? 
						'bg-grey-lighter text-black' : 
						'bg-white text-grey-dark '"
                        :href="`/search?s=all&q=${searchTerm}`"
                    >See all results...</a>
                    <div v-if="entries.length > 0">
                        <a
                            v-for="(entry, index) in entries"
                            :key="entry.url"
                            :href="entry.url"
                            class="block p-4 border-t no-underline cursor-pointer text-base hover:bg-grey-lighter hover:text-black"
                            :class="index == selectIndex - 1 ? 
							'bg-grey-lighter text-black' : 
							'bg-white text-grey-dark '"
                        >
                            <div
                                class="flex justify-between items-start"
                                v-if="entry.type != 'category'"
                            >
                                <div class="pr-4 w-2/3 md:w-3/4 t">
                                    {{ entry.title }}
                                    <span
                                        class="text-grey text-sm"
                                        v-if="entry.excerpt"
                                    >
                                        <br />
                                        {{ entry.excerpt.substring(0,100) + "..." }}
                                    </span>
                                </div>
                                <div
                                    class="text-sm w-1/3 md:w-1/4 text-right"
                                    :class="index == selectIndex - 1 ? 
								'text-purple-grey' : 
								'text-grey-light '"
                                >
                                    {{ entry.section }}
                                    <em
                                        v-if="entry.section == 'News'"
                                        class="text-xs"
                                        :class="index == selectIndex - 1 ? 
									'text-purple-grey-light' : 
									'text-grey-light '"
                                    >
                                        <br />
                                        {{ entry.formattedCreatedDate }} ago
                                    </em>
                                </div>
                            </div>

                            <div
                                class="flex justify-between items-start"
                                v-else-if="entry.type == 'category'"
                            >
                                <div class="pr-4 w-2/3 md:w-3/4 t">
                                    {{ entry.name }}
                                    <span
                                        class="text-grey text-sm"
                                        v-if="entry.related_terms"
                                    >
                                        <br />
                                        {{ entry.related_terms.substring(0,100) + "..." }}
                                    </span>
                                </div>
                                <div
                                    class="text-sm w-1/3 md:w-1/4 text-right"
                                    :class="index == selectIndex - 1? 
								'text-purple-grey' : 
								'text-grey-light '"
                                >
                                    Category
                                    <!-- <em 
									v-if="entry.section == 'News'"
									class="text-xs"
									:class="index == selectIndex ? 
									'text-purple-grey-light' : 
									'text-grey-light '"
									>
									<br>
									{{ entry.formattedUpdatedDate }} ago
                                    </em>-->
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
.is-loading {
    span::after {
        top: 0;
        right: 0;
    }
}
</style>
